const data = {
  resume: {
    preview_link: "https://drive.google.com/file/d/1jpTGtWO7QelAqqyAxooFjeLmHeng8_76/preview",
    direct_download_text: "Download Resume",
    direct_download_link: "https://drive.google.com/uc?export=download&id=1jpTGtWO7QelAqqyAxooFjeLmHeng8_76",
  },
};

export default data;
